<template>
    <div class="truncated-text-tooltip">
        <RedesignTooltip
            placement="top"
            :disabled="!isTruncated"
        >
            <template #tooltip-content>
                <div style="max-width: 320px">
                    {{ text }}
                </div>
            </template>
            <span
                ref="el"
                class="truncated-text-tooltip__text block w-full truncate"
                :class="[contentClass, { 'cursor-pointer': isTruncated }]"
                :style="contentStyle"
                :aria-label="isTruncated ? text : undefined"
                :data-testid="testId"
            >
                {{ text }}
            </span>
        </RedesignTooltip>
    </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref, watch, type CSSProperties } from 'vue'
import { useResizeObserver } from '@vueuse/core'
import RedesignTooltip from '@/components/RedesignBaseComponents/RedesignTooltip.vue'

const props = withDefaults(defineProps<{
    text: string
    contentClass?: string | Record<string, boolean> | Array<string | Record<string, boolean>>
    contentStyle?: CSSProperties
    testId?: string
}>(), {})

const el = ref<HTMLElement | null>(null)
const isTruncated = ref(false)

function updateTruncation () {
    const node = el.value
    isTruncated.value = !!node && node.scrollWidth > node.clientWidth
}

useResizeObserver(el, updateTruncation)
watch([() => props.text, () => props.contentStyle], () => nextTick(updateTruncation))
</script>

<style scoped>
.truncated-text-tooltip {
    @apply block w-full min-w-0;
}
</style>
